import { render, staticRenderFns } from "./footerLinks.vue?vue&type=template&id=7754fe0d"
import script from "./footerLinks.vue?vue&type=script&lang=js"
export * from "./footerLinks.vue?vue&type=script&lang=js"
import style0 from "./footerLinks.vue?vue&type=style&index=0&id=7754fe0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports